import { Drawer, Typography } from "@mui/material";
import React from "react";
import "./timelinedrawer.scss";
import closeIcon from "../../../assets/images/closeIcon.svg";
import timelineError from "../../../assets/images/timelineError.svg";
import { pageLocale } from "../../../utlis/locale";

const TimeLineDrawer = ({
  openTimelineDrawer,
  timelineCloseHandler,
  timeline,
}) => {
  const { timelinetext, timeline_error } = pageLocale("landing");
  return (
    <Drawer
      anchor={"right"}
      open={openTimelineDrawer}
      onClose={() => timelineCloseHandler()}
      className="timeline-drawer-wrapper"
    >
      <div className="timeline-drawer-main">
        <div className="header-wrap">
          <div className="close-wrapper">
            <img
              src={closeIcon}
              className="close-icon"
              onClick={() => timelineCloseHandler()}
              alt="close"
            />
          </div>
          <Typography className="timeline-header">{timelinetext}</Typography>
          <div className="dashed-line" />
        </div>
        {timeline.length > 0 ? (
          <div className="timeline-info-main-wrapper">
            {timeline?.map((item, index) => {
              return (
                <div key={index}>
                  <div className="timeline-message-wrapper">
                    <div className="timeline-icon-wrap">
                      <img
                        src={item.iconURL}
                        alt="timeline"
                        className="timeline-icon"
                      />
                    </div>
                    <div className="timeline-message-info-wrap">
                      <Typography
                        className={`msg-title ${item.isRead === true ? "unread" : "read-item"}`}
                      >
                        {item.action}
                      </Typography>
                      <Typography className="msg-desc">
                        {item.summary}
                      </Typography>
                    </div>
                  </div>
                  <Typography className="message-time-show">
                    {item.time}
                  </Typography>
                  <div className="dashed-line" />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="timeline-error-wrapper">
            <img src={timelineError} alt="error" />
            <Typography>{timeline_error}</Typography>
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default TimeLineDrawer;
